import { createLocation, deleteLocation, editLocation, getLocationsList, getCompanyLocationsById,
  getEmployerLocationsList } from '../api';
import { sortArrayByFieldAsc } from '../helpers/general';
import { dispatchErrorAction } from './index';
import * as actionTypes from './actionTypes';
import UsersService from '../services/UsersService';

export function getLocationsListAction () {
  return dispatch => getLocationsList()
    .then(data => {
      const sortedLocationsList = sortArrayByFieldAsc(data.data, 'label_en');
      dispatch({ type: actionTypes.GET_LOCATIONS_LIST_SUCCESS, locationsList: sortedLocationsList });
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function getCompanyLocations (id) {
  const getDataAction = () => UsersService.isAdmin() ? getCompanyLocationsById(id) : getEmployerLocationsList();
  return dispatch => getDataAction()
    .then(data => {
      const locationsList = data.data;
      dispatch({ type: actionTypes.SET_COMPANY_LOCATIONS, locations: locationsList });
      return locationsList;
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function addUserLocation (data) {
  return async dispatch => dispatch({ type: actionTypes.ADD_COMPANY_LOCATION, data });
}

export function createNewLocation (locationData) {
  return dispatch => createLocation(locationData)
    .then(({ data }) => data)
    .catch(error => {
      dispatchErrorAction(error, dispatch);
    });
}

export function editLocationPoint (id, payload) {
  return dispatch => editLocation(id, payload)
    .then(({ data }) => data)
    .catch(error => {
      dispatchErrorAction(error, dispatch);
    });
}

export function deleteLocationPoint (id) {
  return dispatch => deleteLocation(id)
    .then(({ data }) => data)
    .catch(error => {
      dispatchErrorAction(error, dispatch);
    });
}



// WEBPACK FOOTER //
// ./src/actions/locations.js